<span class="btn-group"><button class="btn btn-default" type="button" :class="{ active: isActive('_score') }" :disabled="!relevanceSortAvailable" @click="sortBy('_score')"><i class="fa fa-sort-amount-desc"></i>

Relevance</button><button class="btn btn-default" type="button" :class="{ active: isActive('pub_date') }" @click="sortBy('pub_date')"><i class="fa fa-sort-numeric-desc"></i>

Pub date</button></span>